module.exports = __webpack_public_path__ + "media/components/country-flag/static/es-ga-a6077d798b37bc9f07e4c4a290e14dd4.svg";